/* eslint-disable */
import Typography from '../Atoms/Typography';
import { useSelector } from 'react-redux';
import { Icon } from '../Icons';
import { sendAmplitudeEvents } from '../../utils/common';
import { EventNames } from '../../utils/events';

function ZohoChatSupport() {
  const currentConfigurationQuickRun = useSelector(
    (state) => state.onboarding?.currentConfigurationQuickRun
  );
  let isQuickRunPage = window.location.pathname.indexOf('quick-run') !== -1;
  let isSamplePage = window.location.pathname.indexOf('sample') !== -1;
  let isYamlPage = window.location.pathname.indexOf('custom') !== -1;
  return (
    <>
      {/* <div
        className="ltw-bg-secondary ltw-flex ltw-items-center ltw-rounded	ltw-py-11px ltw-px-18px ltw-cursor-pointer ltw-flex ltw-gap-9px"
        onClick={() => {
          if (isSamplePage) {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_SUPPORT_CHAT_CLICK_SAMPLE_PAGE
            );
          } else if (isYamlPage) {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_SUPPORT_CHAT_CLICK_YAML_PAGE
            );
          } else {
            sendAmplitudeEvents(EventNames.HYP_ONBOARDING_SUPPORT_CHAT_CLICK);
          }
          openZohoSalesIqChat();
        }}
        onKeyDown={openZohoSalesIqChat}
        role="button"
        tabIndex="0"
      >
        <Icon name="headphone" width="16" height="16" />
        <Typography
          variant="h2"
          fontType="ltw-font-normal"
          color="ltw-text-white"
          cursor="pointer"
        >
          TALK TO OUR AUTOMATION EXPERT
        </Typography>
      </div> */}
      <button
        onClick={(e) => {
          if (isQuickRunPage) {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_VIEW_DOC_QUICK_RUN_PAGE,
              {
                redirectTo: process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK,
                ['testing framework']:
                  currentConfigurationQuickRun?.frameworkType,
                framework: currentConfigurationQuickRun?.framework?.name,
                language: currentConfigurationQuickRun?.framework?.language,
              }
            );
          } else if (isSamplePage) {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_VIEW_DOC_CLICK_SAMPLE_PAGE,
              {
                redirectTo: process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK,
              }
            );
          } else if (isYamlPage) {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_VIEW_DOC_CLICK_YAML_PAGE,
              {
                redirectTo: process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK,
              }
            );
          } else {
            sendAmplitudeEvents(EventNames.HYP_ONBOARDING_VIEW_DOC_CLICK, {
              redirectTo: process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK,
            });
          }
          window
            .open(process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK, '_blank')
            .focus();
        }}
        className="ltw-bg-transparent ltw-border ltw-border-primary ltw-rounded ltw-px-14px ltw-py-10px ltw-flex ltw-items-center zoho-chart-button"
      >
        <Typography
          variant="h2"
          color="ltw-text-primary"
          fontSize="ltw-text-13"
          lineHeight="ltw-leading-16"
          cursor="pointer"
          className="zoho-chart-container-text"
        >
          View Docs
        </Typography>
        <Icon
          name={'expand'}
          width="10"
          height="16"
          className={'ltw-mx-8px ltw-inline-block'}
        />
      </button>
    </>
  );
}

export default ZohoChatSupport;
